import React from 'react';
import classNames from 'classnames';

import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import ReactTooltip from 'react-tooltip';
import FileUpload from '../../FormComponents/FileUpload.jsx'
import DropDown from '../../FormComponents/DropDown.jsx'

const dropdownOptions= [{
        value: "NONE",
        label: "NONE"
    }, {
        value: "METFILE",
        label: "METFILE"
    }, {
        value: "LGTRAIN",
        label: "LGTRAIN"
    }, {
        value: "MODRAIN",
        label: "MODRAIN"
    }, {
        value: "HVYRAIN",
        label: "HVYRAIN"
    }, {
        value: "LGTSNOW",
        label: "LGTSNOW"
    }, {
        value: "MODSNOW",
        label: "MODSNOW"
    }, {
        value: "HVYSNOW",
        label: "HVYSNOW"
    }]

const OnSiteFile = props => (
    <div className="form-input-container">
        <div ><b></b></div>
        <FormControl className={classNames(props.classes.margin, props.classes.formControl)}>
            <InputLabel shrink>OnSite Latitude</InputLabel>
            <Input
                data-tip data-for="osLat"
                inputProps={{ min: "-90", max: "90", step: "any" }}
                type="number"
                name="osLat"
                value={props.osLat}
                onChange={props.handleInputChange}/>
        </FormControl>
        <ReactTooltip id='osLat' place="bottom" type="light" effect="solid">
            Onsite surface station latitude in decimal degrees from -90 to 90.
        </ReactTooltip>

        <FormControl className={classNames(props.classes.margin, props.classes.formControl)}>
            <InputLabel shrink>OnSite Longitude</InputLabel>
            <Input
                data-tip data-for="osLon"
                inputProps={{ min: "-180", max: "180", step: "any" }}
                type="number"
                name="osLon"
                value={props.osLon}
                onChange={props.handleInputChange}/>
        </FormControl>
        <ReactTooltip id='osLon' place="bottom" type="light" effect="solid">
            Onsite surface station longitude in decimal degrees from -180 to 180.
        </ReactTooltip>

        <FormControl className={classNames(props.classes.margin, props.classes.formControl)}>
            <InputLabel shrink>OnSite Elevation (m)</InputLabel>
            <Input
                data-tip data-for="osElev"
                inputProps={{ min: "0", max: "9999", step: "any" }}
                type="number"
                name="osElev"
                value={props.osElev}
                onChange={props.handleInputChange}/>
        </FormControl>
        <ReactTooltip id='osElev' place="bottom" type="light" effect="solid">
            Onsite elevaion above ground in meters.
        </ReactTooltip>

        <InputLabel shrink>Global Precipiatation</InputLabel>
            <TextField
                select
                style={{width: '150px', paddingLeft: '20px'}}
                name='os_pr_type'
                data-tip data-for='os_pr_type'
                value={props.os_pr_type}
                onChange={props.handleInputChange}>

                {dropdownOptions.map(option => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </TextField>
            <ReactTooltip id='os_pr_type' place="bottom" type="light" effect="solid">
                Precipiatation for Onsite Station, (Currently not read in from file.)
            </ReactTooltip>
    </div>
)
export default OnSiteFile;
